import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, toastSuccess, exhibitionOtherAreaActionId } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getGateMasterList_action, deleteGateMaster_action } from "../../../../actions/admin_module_action/master_action/gate_master_action";
import Footer from "../../../../common_components/Footer";


class GateMasterList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            exhibitionList: [],
            gateMasterList: [],
            exhibitionID: '',
            gateName: '',
            deleteID: '',
            ExhibitionOtherAreaID: '',
            ExhibitionOtherAreaList: []
        }

        this.getFillList = this.getFillList.bind(this)
        this.record = this.record.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.deleteGateMaster = this.deleteGateMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.getgateMasterList = this.getgateMasterList.bind(this)
    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '', '');
        this.getFillList(exhibitionOtherAreaActionId, '', '', '', '', '');

        this.setState({
            exhibitionID: sessionStorage.getItem("ExhibitionGate") || '',
            gateName: sessionStorage.getItem("gateNameGate") || '',
            ExhibitionOtherAreaID: sessionStorage.getItem("ExhibitionOtherAreaIDGate") || '',
        }, () => this.getgateMasterList())
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === exhibitionActionId) {
                        this.setState({
                            exhibitionList: data.data
                        })
                    }
                    if (actionID === exhibitionOtherAreaActionId) {
                        this.setState({
                            ExhibitionOtherAreaList: [{ ExhibitionOtherAreaID: 0, Name: 'All' }, ...data.data]
                        })
                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    record(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        {/* <th className="text-center">Role ID</th> */}
                        {/* <th className="text-center">From Date</th>
                        <th className="text-center">To Date</th>
                    <th className="text-center">Country</th> */}
                        <th className="text-center" style={{ width: '50px' }}>Sr no.</th>
                        <th className="text-center"> Gate Name</th>
                        <th style={{ width: '60px' }} className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    <td className="text-center" style={{ width: '50px' }}>{i + 1}</td>
                                    <td className="text-center">{data.GateName}</td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            onClick={(e) => this.handleUpdate(data.GateID, data.ExhibitionID)}
                                        >
                                            Update
                                        </button>
                                        &nbsp;
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={(e) => this.onDelete(data.GateID)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    getgateMasterList() {
        this.setState({ isLoading: true })
        const { gateName} = this.state
        this.props.getGateMasterList_action( gateName)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ gateMasterList: data.data })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { exhibitionID, gateName } = this.state
        sessionStorage.removeItem("ExhibitionGate")
        sessionStorage.removeItem("gateNameGate")
        sessionStorage.removeItem("ExhibitionOtherAreaIDGate")
        this.setState({
            exhibitionID: '',
            gateName: '',
            ExhibitionOtherAreaID: '',
        }, () => this.getgateMasterList())
    }

    handleAdd() {
        this.props.navigate('/gateMasterAU', { state: { is_add: true, } })
    }

    handleUpdate(id, ExhibitionID) {
        this.props.navigate('/gateMasterAU', { state: { is_update: true, gateID: id, exhibitionID: ExhibitionID } })
    }

    deleteGateMaster(id) {
        this.setState({ isLoading: true })
        this.props.deleteGateMaster_action(id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getgateMasterList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(i) {
        const { } = this.state
        this.setState({ deleteID: i })
        this.setState({ isOpen: true, })
    }

    updateItem(item) {
        const { gateMasterList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = gateMasterList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(gateMasterList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }


    render() {
        const { isOpen, isLoading, exhibitionID, currentPage, gateMasterList, exhibitionList, gateName, ExhibitionOtherAreaID, ExhibitionOtherAreaList } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = gateMasterList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(gateMasterList.length / recordsPerPage)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">

                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Gate List</h6>
                            </div>
                        </div>
                        {/* <div className="app-content with-dr-container com-height"> */}
                        <div className="admin-top-space p-2">
                                {
                                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                    <div className="row m-0">
                                        <div className="col-md-4">
                                            <label>Gate Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={gateName}
                                                onChange={(e) => this.setState({ gateName: e.target.value, }, () => sessionStorage.setItem("gateNameGate", e.target.value))}
                                            />
                                        </div>
                                         < div className="col-md-8 pe-2 text-end">
                                         <label></label>

                                {
                                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                    <div
                                       
                                        role="group"
                                        aria-label="Basic example"
                                        
                                    >
                                        <button type="button" className="btn btn-aqua"
                                            onClick={e => this.getgateMasterList()}
                                        >
                                            Search
                                        </button>
                                        <button type="button" className="btn btn-aqua mx-2"
                                            onClick={e => this.handleAdd()}
                                        >
                                            Add
                                        </button>
                                        <button type="button" className="btn btn-gray"
                                            onClick={e => this.clearSearch()}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                }

                            </div>
                                    </div>
                                }
                           
                            <div className="table-responsive sticky-table-wrapper px-2 mt-3">
                                {this.record(currentRecords)}
                            </div>
                            <div className="mt-2 float-left trp ms-2">
                                {
                                    gateMasterList.length > 0 ?
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={this.updateItem}
                                        /> : <></>
                                }
                                <div className="table-record-pages " style={{ float: "right" }}>
                                    <p>{`${currentPage} of ${nPages} pages`}</p>
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text">Do you really want to delete this record?</h5>

                                {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua"
                                        onClick={(e) => this.deleteGateMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getGateMasterList_action, deleteGateMaster_action })(GateMasterList));